// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__6mTuF","header":"PatientBlock_header__2Uolb","label":"PatientBlock_label__3AZDn","option":"PatientBlock_option__2zN8w"};